export type TaskList = {
  id: string;
  ownerUserId: string;
  name: string;
  orderIndex: number;
  participantUserIds: string[];
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
};

export type CreateTaskListInput = {
  name: string;
};

export type UpdateTaskListInput = {
  name?: string;
  orderIndex?: number;
  participantUserIds?: string[];
};

export type DeleteTaskListAction =
  | { action: 'move'; targetListId: string }
  | { action: 'delete' };

export const TASK_LIST_OWNED_CAP = 5;
export const TASK_LIST_NAME_MAX = 40;
